import { Component } from '@angular/core';
import { ItemsListRowItemBase } from '@fi-app/components/items-list/list-row/list-row-item/list-row-item-base';

@Component({
    selector: 'checklist-list-item-colour-indicator',
    template: '<span class="colour-icon colour-icon-{{data.AnswersStatus}}"></span>',
    standalone: false,
})
export class ChecklistListItemColourIndicatorComponent extends ItemsListRowItemBase {
    data: { AnswersStatus: number };
}
